<script>
	import { getCountLabel, isDefined, isSameId } from "@xbs/lib-todo";
	import { getContext } from "svelte";

	import { Dropdown } from "@xbs/svelte-wx";
	import Separator from "../../library/Separator.svelte";
	import Icon from "../../library/Icon.svelte";
	import Input from "../../library/Input.svelte";
	import Text from "../../library/Text.svelte";
	import List from "../../library/List.svelte";
	import Item from "../Menu/Items/Item.svelte";

	export let api;

	const _ = getContext("wx-i18n").getGroup("todo");

	let self = null;

	$: state = api.getReactiveState();

	$: editor = state.stateEditableItem;
	$: activeProject = state.activeProject;
	$: projects = state.projects;
	$: tasks = state.tasks;
	$: componentId = state.id;
	$: readonly = state.readonly;
	$: dropdown = state.stateCombo;

	$: editing =
		isSameId($editor?.id, $activeProject) && $editor?.type === "project";

	$: visibleProjects =
		$projects.every(p => isDefined(p.id)) &&
		$tasks.some(t => !isDefined(t.project) && !isDefined(t.parent))
			? [{ id: null, label: _("No project") }, ...$projects]
			: [...$projects];
	$: projectLabel = (
		visibleProjects.find(p => isSameId($activeProject, p?.id))?.label ||
		_("No project")
	).trim();

	let search = null;
	let searchResult = [];

	$: {
		if (isDefined(search)) {
			searchResult = visibleProjects.filter(({ label }) =>
				label.toLowerCase().includes(search.toLowerCase())
			);
		} else {
			searchResult = visibleProjects;
		}
		searchResult = searchResult.map(i => {
			const icon = isSameId(i.id, $activeProject) ? "check" : "empty";
			return { ...i, icon };
		});
	}

	function toggleDropdown(event) {
		search = null;
		if (self.contains(event?.target)) {
			api.exec("set-state-combo", { open: !$dropdown?.open });
		}
	}

	function closeDropdown(event) {
		search = null;
		if ($dropdown.open && !self.contains(event?.target)) {
			api.exec("set-state-combo", { open: false });
		}
	}

	function dropdownItemClick(event) {
		api.exec("set-project", { id: event.detail.id });
		closeDropdown(event);
	}

	function openEditor() {
		api.exec("open-inline-editor", {
			id: $activeProject,
			type: "project",
		});
	}

	function closeEditor() {
		isDefined($editor?.id) &&
			api.exec("close-inline-editor", {
				id: $editor.id,
			});
	}

	function editingItem(event) {
		const value = event.detail.value.trim();
		const otherProjects = $projects.filter(
			({ label }) => label !== projectLabel
		);

		api.exec("edit-item", {
			id: $editor.id,
			currentValue: value.length
				? value
				: getCountLabel("Untilted", otherProjects, _),
		});
	}

</script>

<div data-todo-id={$componentId} class="wx-todo_combo">
	<div
		bind:this={self}
		class="wx-todo_combo__wrapper"
		on:click={toggleDropdown}>
		<Text
			{editing}
			value={projectLabel}
			enableRange={true}
			placeholder={_('Type what you want')}
			editable={isDefined($activeProject) && !$readonly}
			on:close={closeEditor}
			on:open={openEditor}
			on:editing={editingItem} />
		<div class="wx-todo_combo__icon">
			<Icon name={'menu-down'} clickable />
		</div>
	</div>
	{#if $dropdown?.open && !editing}
		<Dropdown width={'fit-content'} cancel={closeDropdown}>
			<div class="wx-todo_combo-dropdown">
				<div class="wx-todo_combo-search">
					<div class="wx-todo_combo-search__icon">
						<Icon name="search" />
					</div>
					<Input
						placeholder={_('Search project')}
						bind:value={search} />
				</div>
				<Separator padding={'0'} />
				<List
					options={searchResult}
					on:click={dropdownItemClick}
					let:item>
					<Item {item} />
				</List>
			</div>
		</Dropdown>
	{/if}
</div>

<style>
	.wx-todo_combo {
		position: relative;
		display: flex;
		align-items: center;
		justify-content: flex-start;

		height: 100%;
		width: 100%;
		margin-right: 12px;
		margin-left: 22px;
	}
	.wx-todo_combo__wrapper {
		display: flex;
	}
	.wx-todo_combo-search {
		display: flex;
		align-items: center;
		justify-content: flex-start;

		padding: 8px;
	}
	.wx-todo_combo-search .wx-todo_combo-search__icon {
		margin-right: 8px;
	}

</style>
